import { injectable } from 'inversify-props';
import BaseService from '@/services/base-service';
import CaptureMethodModel from '@/models/crm/capture-method.model';

@injectable()
export default class CaptureMethodService extends BaseService {
  async getCaptureMethods(): Promise<CaptureMethodModel[]> {
    return (await this.httpService.get(
      CaptureMethodModel,
      `${this.getApiPath()}/crm/capture-method/list`,
    )) as CaptureMethodModel[];
  }
}
